"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TruncateText = void 0;
var temas_frontend_1 = require("@aura/temas-frontend");
var react_1 = __importStar(require("react"));
var react_text_truncate_1 = __importDefault(require("react-text-truncate"));
var paragraphy_styles_1 = require("../../token/paragraphy/paragraphy.styles");
var styles_1 = require("./styles");
var TruncateText = function (_a) {
    var id = _a.id, truncateText = _a.truncateText, truncateLines = _a.truncateLines;
    var theme = (0, temas_frontend_1.useTheme)().theme;
    var _b = (0, react_1.useState)(false), expanded = _b[0], setExpanded = _b[1];
    var _c = (0, react_1.useState)(false), truncated = _c[0], setTruncated = _c[1];
    var _d = (0, react_1.useState)({ width: 0, height: 0 }), dimensions = _d[0], setDimensions = _d[1];
    var containerRef = (0, react_1.createRef)();
    (0, react_1.useEffect)(function () {
        var handleResize = function () {
            var _a, _b;
            setDimensions({ width: (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth, height: (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight });
        };
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    });
    var lines = !expanded && truncateLines;
    var toggleLines = function (event) {
        event.preventDefault();
        setExpanded(!expanded);
    };
    var handleTruncate = function (trunc) {
        if (truncated !== trunc) {
            setTruncated(trunc);
        }
    };
    return (react_1.default.createElement(styles_1.TruncateSectionStyled, { id: id, ref: containerRef },
        react_1.default.createElement(react_text_truncate_1.default, { width: dimensions.width, lines: lines, ellipsis: react_1.default.createElement(styles_1.ContainerTruncateMoreStyled, { onClick: toggleLines },
                react_1.default.createElement(paragraphy_styles_1.PStyled, { p12: true, bold: true, color: theme.action001 }, "\u00A0Ler mais")), onTruncate: handleTruncate }, truncateText),
        !truncated && expanded && (react_1.default.createElement(styles_1.ContainerTruncateMoreStyled, { onClick: toggleLines },
            react_1.default.createElement(paragraphy_styles_1.PStyled, { p12: true, bold: true, color: theme.action001 }, "\u00A0Ler menos")))));
};
exports.TruncateText = TruncateText;
